import { queryOptions, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const adPlacementsQueryOptions = queryOptions({
  queryKey: ['ad-placements'],
  queryFn: async () => {
    const now = new Date().toISOString();
    const { data, error } = await supabase
      .from('ad_placements')
      .select('card_id, priority, label')
      .or(`start_at.is.null,start_at.lte.${now}`)
      .or(`end_at.is.null,end_at.gte.${now}`);

    if (error) throw error;
    return data || [];
  },
  staleTime: 10 * 60 * 1000, // 10 minutes - ads change infrequently
  gcTime: 30 * 60 * 1000,
});

export const useAdPlacements = () => useQuery(adPlacementsQueryOptions);
